import { useAppSelector } from "../../../../../stateManagement/hooks/redux"

// RoadDiagnosticsSegmentsPassport
export default function RDSPContent() {
    const mapTooltip = useAppSelector(state => state.mapTooltip)
    const { length, executorOrgName } = mapTooltip ?? {}

    return (
        <>
            <div className="tooltip-info-row">Протяжённость: {length} км</div>
            <div className="tooltip-info-row">Исполнитель: {executorOrgName ?? 'Не известен'}</div>
        </>
    )
}
